//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
import { v4 } from 'uuid';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const createKeystore = async (userId, key) => {
    try {
        await apis.post('keystore', `/keystore`, {
            body: {
                userId,
                key
            }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating keystore',
                error,
                module: 'KEYSTORE',
                operation: 'CREATE_KEYSTORE'
            });
        }
    }
};
export const getKeystore = async (key) => {
    try {
       return await apis.get('keystore', `/keystore/${key}`);
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting keystore',
                error,
                module: 'KEYSTORE',
                operation: 'GET_KEYSTORE'
            });
        }
        return null;
    }
};

export const impersonateTeacher = async (orgId) => {
    try {
        return await apis.post('keystore', '/keystore/impersonate-teacher', {
            body: { orgId }
        });
    } catch (error) {
        console.error('Error impersonating teacher:', error);
    }
    return null;
};


// export const openLoginInNewWindow = async (userId) => {
//     const key = v4()
//     await createKeystore(userId, key)
//     const url = `${window.location.origin}?key=${key}`
//     window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
//   }

//   export const openLoginInNewWindow = async (userId) => {
//     const key = v4();
//     const url = `${window.location.origin}?key=${key}`;
//     const features = 'toolbar=0,location=0,menubar=0';
  
//     try {
//       const newWindow = window.open('', '_blank', features);
//       if (!newWindow) {
//         alert('Pop-up blocked! Please allow pop-ups for this site.');
//         return;
//       }
//       await createKeystore(userId, key);
//       newWindow.location.href = url;
//     } catch (error) {
//       console.error('Error opening login window:', error);
//     }
//   };



export const openLoginInNewWindow = async (userId,root) => {
    const key = v4();
    const url = `${window.location.origin}?key=${key}${root?"&role="+root:''}`;
    const features = 'toolbar=0,location=0,menubar=0';
  
    const handleOpenWindow = async () => {
      try {
        await createKeystore(userId, key)
        const newWindow = window.open('', '_blank', features);
        if (!newWindow) {
          alert('Pop-up blocked! Please allow pop-ups for this site.');
          return;
        }
        newWindow.location.href = url;
      } catch (error) {
        console.error('Error opening login window:', error);
      }
    };
    
   return handleOpenWindow();
  };
  
export const openAutologin = async (schoologyid) => {
    const features = 'toolbar=0,location=0,menubar=0';
  
    const handleOpenWindow = async () => {
      try {
        if (!schoologyid) {
          return {
            success: false,
            message: 'Schoology ID not found for this user'
          };
        }

        const response = await apis.get("schoologyRDS", `/getAutologinUrl/${schoologyid}`);
        
        if (response && response.success && response.url) {
          const newWindow = window.open('', '_blank', features);
          if (!newWindow) {
            return {
              success: false,
              message: 'Pop-up blocked! Please allow pop-ups for this site.'
            };
          }
          newWindow.location.href = response.url;
          return {
            success: true
          };
        } else {
          return {
            success: false,
            message: response?.message || 'Autologin URL not found for this user'
          };
        }
      } catch (error) {
        console.error('Error fetching autologin URL:', error);
        if (error && error.message != "Network Error") {
          logToSentry({
            message: 'fetching autologin URL',
            error,
            module: 'KEYSTORE',
            operation: 'GET_AUTOLOGIN_URL'
          });
        }
        return {
          success: false,
          message: 'Error fetching autologin URL. Please try again.'
        };
      }
    };
    
    return handleOpenWindow();
};
  

  